<template>
  <div class="container-detail">

    <van-form @submit="onApplySubmit">
      <!-- 主题信息 -->
      <div class="container-page-body">
        <div class="pages-list">
          <!-- 申请信息 -->
          <div class="pages-box">
            <van-cell-group>
              <van-field
                  readonly
                  clickable
                  required
                  input-align="right"
                  label="报修类型"
                  v-model="data.lookForm.repairTypeName"
                  placeholder="请选择"
                  @click="showPicker = true"
              />
              <van-popup v-model:show="showPicker" round position="bottom">
                <van-picker
                    title="报修类型"
                    show-toolbar
                    :columns="selectForm.repairType"
                    @cancel="showPicker = false"
                    @confirm="onTypeConfirm"
                >
                  <template #option="option">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                      <div>{{ option.name }}</div>
                    </div>
                  </template>
                </van-picker>
              </van-popup>
              <div class="pages-box-line"></div>
              <div class="pages-box-input">
                <div class="title"><span class="require">*</span><span class="info">报修范围</span></div>
                <div class="box">
                  <van-skeleton
                      :row="2"
                      :loading="repairScopeLoading"
                      animate
                      round
                  >
                    <div v-for="(item, index) in selectForm.repairScope" :key="index"
                         :class="['box-item', {'active':data.lookForm.repairScope===item.id}]"
                         @click="clickRepairScope(item)">{{ item.name }}
                    </div>
                  </van-skeleton>
                </div>
              </div>
              <div class="pages-box-line"></div>
              <van-field
                  v-model="data.lookForm.repairAddress"
                  required
                  label="报修地址"
                  placeholder="请输入"
                  input-align="right"
              />
            </van-cell-group>
          </div>
          <!-- 报修问题 -->
          <div class="pages-box">
            <van-field
                class="popup-search-body__textarea"
                v-model="feedbackForm.feedback"
                rows="4"
                autosize
                maxlength="200"
                type="textarea"
                placeholder="请输入反馈内容（必填）"
                show-word-limit
            />
            <div class="pages-box-line"></div>
            <div class="pages-box-uploader">
              <div class="img-list">
                <div class="item" :key="index" v-for="(item, index) in imageList">
                  <img class="img"
                       :src="item.url && item.url.indexOf('http') != -1? item.url: FILEBASEURL + item.url"
                       alt=""/>
                  <span class="del" @click="delImg(index)"><van-icon name="clear" color="#A9A9B7"/></span>
                </div>
              </div>
              <div class="upload" v-show="imageList.length<4">
                <van-uploader
                    :after-read="afterRead"
                    :max-count="4">
                  <div class="btn">
                    <van-icon name="photo-o" size="20"/>
                    <span class="text">图片</span>
                  </div>
                </van-uploader>
              </div>
            </div>

          </div>
          <!-- 审批流程 -->
          <div class="pages-box">
            <div class="pages-box-title">
              <div class="title">审批流程</div>
              <div class="sort">依次审批</div>
            </div>
            <van-skeleton
                :row="4"
                :loading="approveLoading"
                animate
                round
                :style="'padding:10px'"
            >
              <ProcessEdit
                  ref="processRef"
                  :list="approveInfo.approveList"
                  @add-user="processAddUser"
              />
            </van-skeleton>
          </div>
        </div>
      </div>

      <!-- 底部菜单，管理员 和 维修员 -->
      <div class="container-page-footer">
        <div class="footer-button-list">
          <div class="footer-button-item">
            <van-button round block type="primary" color="button-save" native-type="submit">提交</van-button>
          </div>
        </div>
      </div>
    </van-form>
  </div>
</template>
<script>
import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";
import {Toast, Skeleton, Step, Steps, Button, Popup, Picker} from "vant";
import {useStore} from "vuex";
import ProcessEdit from "@/components/process-edit/componemts/edit-item.vue";
import Compressor from "compressorjs";

export default {
  name: "applyDetail",
  components: {
    [Skeleton.name]: Skeleton,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    ProcessEdit,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const FILEBASEURL = ref(process.env.VUE_APP_BASE_File_URL);
    let loading = ref(true);
    let approveLoading = ref(false);
    let repairScopeLoading = ref(true);
    let showPicker = ref(false);
    let id = ref('');
    let selectForm = ref({
      repairType: [],
      repairScope: [],
    });
    let feedbackForm = ref({
      feedback: '', // 报修问题
      pics: [], // 报修图片
    });
    let allowFileExt = ref(['image/jpg', 'image/jpeg', 'image/png', 'image/gif']);
    let fileList = ref([]);
    let imageList = ref([]);
    let data = ref({
      lookForm: {
        applyPhone: '',
        applyUserName: '',
        approveCode: '',
        createTime: '',
        id: '',
        isCanDistribute: '',
        msg: '',
        pics: [],
        repairAddress: '', // 报修地址
        repairFeedRecordVOS: [],
        repairScope: '', // 报修范围
        repairScopeName: '', // 报修范围名称
        repairStatus: '',
        repairTime: '',
        repairType: '', // 报修类型
        repairTypeName: '', // 报修类型名称
        repairUserName: '',
        repairUserPhone: '',
        status: '',
        statusName: '',
      },
    });

    const getDictionaryListApi = (params) => store.dispatch("repair/getDictionaryList", params);

    const getDictList = async (type) => {
      let searchName;
      if (type === 1) {
        searchName = "报修类型";
      } else if (type === 2) {
        searchName = "报修范围";
      }
      let r = await getDictionaryListApi({
        dictionaryTypeName: searchName,
      });
      if (r.message == "success") {
        if (type === 1) {
          selectForm.value.repairType = r.data.list;
        } else if (type === 2) {
          selectForm.value.repairScope = r.data.list;
          repairScopeLoading.value = false;
        }
      }
    };

    const onTypeConfirm = (value) => {
      console.log('onTypeConfirm', value);
      data.value.lookForm.repairType = value.id;
      data.value.lookForm.repairTypeName = value.name;
      showPicker.value = false
      workflowConditionServe();
    };

    const clickRepairScope = (value) => {
      console.log('clickRepairScope', value);
      data.value.lookForm.repairScope = value.id;
      data.value.lookForm.repairScopeName = value.name;
      workflowConditionServe();
    };

    const btnAdd = () => {
      console.log('btnAdd');
    };

    const getApplyDetail = () => {
      console.log('getApplyDetail', id.value)
    };

    const buttonEdit = () => {
      console.log('编辑');
    };

    const postRepairAddApi = (params) => store.dispatch("repair/postRepairAdd", params);
    const onApplySubmit = async () => {
      console.log('提交', feedbackForm.value.pics, imageList.value);
      if (data.value.lookForm.repairType === '') {
        Toast.fail('请选择报修类型');
        return;
      }
      if (data.value.lookForm.repairScope === '') {
        Toast.fail('请选择报修范围');
        return;
      }
      if (data.value.lookForm.repairAddress === '') {
        Toast.fail('请填写报修地址');
        return;
      }
      if (feedbackForm.value.feedback === '') {
        Toast.fail('请输入反馈内容');
        return;
      }
      console.log('111', data.value.lookForm);

      if (!approveInfo.value || !approveInfo.value.approveList || approveInfo.value.approveList[0].selectedUserList.length < 1) {
        Toast.fail('请选择审批人');
        return;
      }

      // if (approveInfo.value.approveList[1].selectedUserList&&approveInfo.value.approveList[1].selectedUserList.length < 1) {
      //   Toast.fail('请选择抄送人');
      //   return;
      // }

      let r = await postRepairAddApi({
        repairAddress: data.value.lookForm.repairAddress,
        repairScope: data.value.lookForm.repairScope,
        repairScopeName: data.value.lookForm.repairScopeName,
        repairType: data.value.lookForm.repairType,
        repairTypeName: data.value.lookForm.repairTypeName,
        msg: feedbackForm.value.feedback,
        fileIdList: feedbackForm.value.pics,
        approveParam: {
          approveList: approveInfo.value.approveList,
          bizType: 'repair',
          flowCode: approveInfo.value.flowCode,
          isExistApprove: approveInfo.value.isExistApprove,
        },
      });
      if (r && r.message === "success") {
        // data.value.lookForm.repairAddress =  '';
        // data.value.lookForm.repairScope =  '';
        // data.value.lookForm.repairScopeName = '';
        // data.value.lookForm.repairType = '';
        // data.value.lookForm.repairTypeName = '';
        // feedbackForm.value.feedback = '';
        // feedbackForm.value.pics = [];
        // fileList.value = [];
        // approveInfo.value = [];
        store.commit("studentLeave/setBackupData", {
          repairAddress: '',
          repairScope: '',
          repairScopeName: '',
          repairType: '',
          repairTypeName: '',
          msg: '',
          fileIdList: [],
          fileList: [],
          imageList: [],
          approveInfo: {},
          processAddIndex: '',
        });
        Toast.success('添加成功');
        router.push('/repair/report/apply')
      } else {
        Toast.fail('添加失败')
      }
    };

    const afterDelete = (file, index) => {
      console.log('afterDelete', file, index)
      feedbackForm.value.pics.splice(index.index, 1);
      fileList.value.splice(index.index, 1);
      console.log('afterDelete002', feedbackForm.value.pics, fileList.value)
    };
    // const commonSingleFileUploadOssApi = (params) => store.dispatch("repair/commonSingleFileUploadOss", params);
    const compressFile = (file) => {
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          convertSize: 500000,
          success(result) {
            resolve(result);
          },
          error(err) {
            console.log(err.message);
          },
        });
      });
    };
    const uploadOSS = (params) => store.dispatch("common/uploadOSS", params);
    const afterRead = async (file) => {
      let result = await compressFile(file.file);
      let r = await uploadOSS({
        file: result,
        moduleName: "repair",
      });
      if (r.success) {
        let {id, url} = r.data;
        feedbackForm.value.pics = feedbackForm.value.pics.concat(id);
        imageList.value = imageList.value.concat({id: id, url: url, file: result})
      } else {
        Toast.fail("文件上传失败，请重新上传！");
      }
      // let suffix = file.file.type.split('/');
      // let fileName = file.file.name
      // let dataArr = {
      //   file: file.file,
      //   name: fileName,
      //   objectType: 4,
      //   postfix: suffix[1] || 'jpg',
      //   size: parseInt(file.file.size / 1000),
      //   sizeUnits: 'kb',
      // };
      // const bodyFormData = new FormData();
      // for (let it in dataArr) {
      //   bodyFormData.append(it, dataArr[it]);
      // }
      // let r = await commonSingleFileUploadOssApi(bodyFormData);
      // if (r && r.message === "success") {
      //   let {fileId, fileName, url} = r.data;
      //   feedbackForm.value.pics = feedbackForm.value.pics.concat(fileId);
      //   imageList.value = imageList.value.concat({id: fileId, name: fileName, url: url})
      // } else {
      //   Toast.fail('上传失败')
      // }
    };
    const delImg = (index) => {
      imageList.value.splice(index, 1);
      feedbackForm.value.pics.splice(index, 1);
    };

    // 添加审批人
    const studentInfo = ref({});
    const backupData = ref(computed(() => store.state.studentLeave.backupData));
    let processAddIndex = backupData.value.processAddIndex || 0;
    const approveInfo = ref(backupData.value.approveInfo);
    const persionSelectedPage = computed(() => store.state.persionSelectedPage); // 选中的审批人

    const workflowCondition = (params) => store.dispatch("studentLeave/workflowCondition", params);
    const workflowConditionServe = async () => {
      console.log('workflowConditionServe', data.value.lookForm.repairType, data.value.lookForm.repairScope)
      if (!data.value.lookForm.repairScope || !data.value.lookForm.repairType) {
        return;
      }
      approveInfo.value = [];
      approveLoading.value = true;

      let r = await workflowCondition({
        bizType: "repair",
        repair: {
          repairRangeId: data.value.lookForm.repairScope,
          repairTypeId: data.value.lookForm.repairType,
        },
      });
      let {success, message} = r;
      if (!success) {
        Toast.fail(message);
      } else {
        approveInfo.value = r.data;
        approveLoading.value = false;
        console.log("审批流", r.data)
      }
    };

    const navigateToObjSelectProcess = (
        checkType,
        limit,
        limitRange,
        defaultList
    ) => {
      console.log(
          'navigateToObjSelectProcess',
          checkType,
          limit,
          limitRange,
          defaultList);
      router.push({
        path: "/studentSelect",
        query: {
          moduleName: "process",
          sourceType: "T",
          resType: "user",
          type: 2,
          scene: "applyRepair",
          checkType,
          limit,
          limitRange,
          defaultList,
        },
      });
    };

    const processAddUser = (cb, i) => {
      processAddIndex = i;
      let {chooseNumber, chooseRange, chooseUserList, selectedUserList} =
          approveInfo.value.approveList[processAddIndex];
      let checkType = chooseNumber == "one" ? "single" : "multiple";
      let limit = chooseRange === "limited";
      let limitRange = [];
      chooseUserList.map((user) => {
        limitRange.push(user.userIndex);
      });
      let defaultList = [];
      if(selectedUserList && selectedUserList.length>0){
         selectedUserList.map((user) => {
        defaultList.push(user.userIndex);
      });
      }
     
      console.log('processAddUser', checkType, limit, limitRange, defaultList);
      navigateToObjSelectProcess(checkType, limit, limitRange, defaultList);
    };

    watch(persionSelectedPage,
        (persionSelectedPage) => {
          console.log('watch:persionSelectedPage', persionSelectedPage.moduleName, persionSelectedPage.data);

          let {moduleName} = persionSelectedPage;
          if (persionSelectedPage.data && persionSelectedPage.data.length) {
            if (moduleName == "repair") {
              studentInfo.value = persionSelectedPage.data[0];
            }
            if (moduleName == "process" && approveInfo.value && approveInfo.value.approveList) {
              persionSelectedPage.data.map((user) => {
                user.userName = user.name;
              });
              approveInfo.value.approveList[processAddIndex].selectedUserList = [
                ...persionSelectedPage.data,
              ];
            }
          } else {
            if (moduleName == "repair") {
              studentInfo.value = {};
            }
            if (moduleName == "process" && approveInfo.value && approveInfo.value.approveList) {
              approveInfo.value.approveList[processAddIndex].selectedUserList =
                  [];
            }
          }
        }, {
          immediate: true,
        }
    );

    onBeforeUnmount(() => {
      let backupData = {
        repairAddress: data.value.lookForm.repairAddress,
        repairScope: data.value.lookForm.repairScope,
        repairScopeName: data.value.lookForm.repairScopeName,
        repairType: data.value.lookForm.repairType,
        repairTypeName: data.value.lookForm.repairTypeName,
        msg: feedbackForm.value.feedback,
        fileIdList: feedbackForm.value.pics,
        fileList: fileList.value,
        imageList: imageList.value,
        approveInfo: approveInfo.value,
        processAddIndex: processAddIndex,
      };
      store.commit("studentLeave/setBackupData", backupData);
    });


    onMounted(() => {
      getDictList(1);
      getDictList(2);
      id.value = router.currentRoute.value.query.id || '';
      getApplyDetail();

      let backupData = store.state.studentLeave.backupData
      data.value.lookForm.repairAddress = backupData.repairAddress || '';
      data.value.lookForm.repairScope = backupData.repairScope || '';
      data.value.lookForm.repairScopeName = backupData.repairScopeName || '';
      data.value.lookForm.repairType = backupData.repairType || '';
      data.value.lookForm.repairTypeName = backupData.repairTypeName || '';
      feedbackForm.value.feedback = backupData.msg || '';
      feedbackForm.value.pics = backupData.fileIdList || [];
      fileList.value = backupData.fileList || [];
      imageList.value = backupData.imageList || [];
      approveInfo.value = backupData.approveInfo || {};
      console.log(approveInfo.value)
    });

    return {
      loading,
      repairScopeLoading,
      showPicker,
      id,
      selectForm,
      feedbackForm,
      allowFileExt,
      fileList,
      imageList,
      FILEBASEURL,
      data,
      processAddIndex,
      approveInfo,
      persionSelectedPage,
      approveLoading,

      onTypeConfirm,
      clickRepairScope,
      btnAdd,
      getApplyDetail,
      buttonEdit,
      onApplySubmit,
      delImg,
      afterDelete,
      afterRead,
      getDictList,
      processAddUser,

    };
  },
};
</script>
<style lang="less" scoped>
.container-page-header {
  height: 100%;
  font-size: 12px;
  margin-bottom: 48px;

  .top-tabs {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
  }

  .page-top-line {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
    height: 3px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F4FA;
  }

  .top-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 900;
    height: 48px;
    color: #fff;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 12px;
    box-sizing: border-box;

    .back {
      width: 36px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .left_img {
        width: 24px;
        height: 24px;
      }
    }

    .page_title {
      font-weight: 500;
      color: #343434;
      line-height: 20px;
      font-size: 18px;
    }
  }
}

.container-page-body {
  background-color: #F2F4FA;

  .pages-list {
    padding: 10px 0 70px 0;
    min-height: 700px;

    .pages-box {
      background-color: #FFFFFF;
      margin-bottom: 8px;
      border-radius: 10px;

      .pages-box-uploader {
        padding: 10px;

        .img-list {
          .item {
            position: relative;
            display: inline-block;
            width: 72px;
            height: 72px;
            margin-bottom: 8px;
            margin-right: 8px;
            border-radius: 2px;

            .img {
              width: 100%;
              height: 100%;
              border-radius: 2px;
              overflow: hidden;
            }

            .del {
              position: absolute;
              right: -10px;
              top: -10px;
              padding: 5px;
            }
          }
        }

        .upload {
          .btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 90px;
            height: 32px;
            color: #333;
            font-size: 15px;
            font-weight: 400;
            background: #ffffff;
            border-radius: 18px;
            border: 1px solid #e5e5e5;

            .text {
              margin-left: 8px;
            }
          }
        }
      }

      .pages-box-line {
        box-sizing: border-box;
        border-bottom: 1px solid #ebedf0;
      }

      .pages-box-input {
        padding: 12px 15.5px;
        font-size: 15px;

        .title {
          .require {
            color: #ee0a24;
          }

          .info {
            margin-left: 2px;
            color: #646566;
            text-align: left;
          }
        }

        .box {
          overflow: hidden;

          .box-item {
            float: left;
            padding: 10px 12px;
            color: #999999;
            background-color: #F2F4FA;
            border-radius: 5px;
            margin-right: 10px;
            margin-top: 10px;
            font-size: 13px;
          }

          .active {
            color: #ffffff;
            background-color: #4174FD;
          }
        }
      }

      .pages-box-title {
        padding: 20px 15px;
        display: flex;
        align-content: center;
        justify-content: space-between;

        .title {
          color: #666666;
          font-size: 15px;
        }

        .sort {
          color: #999999;
          font-size: 13px;
        }
      }

      .pages-box-process {
        padding: 0 15px;
        display: flex;
        align-content: center;
        justify-content: space-between;

        .circle {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background-color: #D8D8D8;
          position: relative;
          top: 8px;
        }

        .label {
          width: 250px;

          .require {
            color: #ee0a24;
            position: relative;
            top: 2px;
          }

          .field {
            color: #333333;
            font-size: 15px;
          }
        }

        .tips {
          color: #999999;
          font-size: 15px;
        }
      }

      .pages-box-people {
        padding: 10px 28px;
        overflow: hidden;

        .pages-box-people-common {
          float: left;

          img {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            margin-left: 5px;
          }
        }

        .pages-box-people-add {
          width: 44px;
          height: 44px;
          background-color: #F2F4F9;
          border-radius: 50%;
          margin-left: 5px;
          text-align: center;
          line-height: 44px;
          color: #4275FD;

          .add {
            line-height: 44px;
          }
        }
      }
    }
  }
}

.container-page-footer {
  position: fixed;
  width: 100%;
  height: 70px;
  bottom: 0;
  background-color: #ffffff;
  border: 1px solid #F2F4FA;
  z-index: 999;

  .footer-button-list {
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footer-button-item {
      width: 100%;
      padding: 0 12px;
    }

    .button {
      border: 1px solid #4275FD;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 30px;
      margin: 0px 10px;
    }
  }
}
</style>
